import Mockman from "mockman-js";

function MockmanPage() {
  return (
    <div className="MockAPI">
      <Mockman />
    </div>
  );
}

export default MockmanPage;
